import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body"]

  connect() {
    this.animation = null
    this.isClosing = false
  }

  disconnect() {
    this.animation?.cancel()
  }

  toggle(event) {
    event.preventDefault()

    this.animation?.cancel()

    if (this.element.open && !this.isClosing) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isClosing = false
    this.element.open = true

    if (this.reducedMotion) return

    const height = this.bodyTarget.scrollHeight

    this.animation = this.bodyTarget.animate(
      [
        {
          height: "0px",
          opacity: 0,
          transform: "translateY(-8px) scaleY(0.97)",
          easing: "cubic-bezier(.55, .06, .68, .19)"
        },
        {
          offset: 0.68,
          height: `${height}px`,
          opacity: 1,
          transform: "translateY(2px) scaleY(1.012)",
          easing: "cubic-bezier(.16, 1, .3, 1)"
        },
        {
          offset: 0.86,
          height: `${height}px`,
          opacity: 1,
          transform: "translateY(-1px) scaleY(0.997)"
        },
        {
          height: `${height}px`,
          opacity: 1,
          transform: "translateY(0) scaleY(1)"
        }
      ],
      { duration: 620, fill: "both" }
    )

    this.animation.addEventListener("finish", () => this.finishAnimation(), { once: true })
  }

  close() {
    this.isClosing = true

    if (this.reducedMotion) {
      this.element.open = false
      this.isClosing = false
      return
    }

    const height = this.bodyTarget.getBoundingClientRect().height

    this.animation = this.bodyTarget.animate(
      [
        {
          height: `${height}px`,
          opacity: 1,
          transform: "translateY(0) scaleY(1)"
        },
        {
          height: "0px",
          opacity: 0,
          transform: "translateY(-6px) scaleY(0.985)"
        }
      ],
      {
        duration: 360,
        easing: "cubic-bezier(.4, 0, .2, 1)",
        fill: "both"
      }
    )

    this.animation.addEventListener(
      "finish",
      () => {
        this.element.open = false
        this.isClosing = false
        this.finishAnimation()
      },
      { once: true }
    )
  }

  finishAnimation() {
    this.animation?.cancel()
    this.animation = null
  }

  get reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
